import { Component, Input } from '@angular/core';
import { BlockListComponent } from 'components/layout/blocklist/blocklist.component';
import { EditQuestionnaireComponent } from 'components/questionnaire/edit-questionnaire.component';
import { CredentialType } from 'enums/CredentialType';
import { QuestionnaireModel } from 'models/generated/Entities.GormCrm.Questionnaire';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { DataTracking } from 'services/data-tracking';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { QuestionnaireService } from 'services/questionnaire.service';

@Component({
	selector: 'list-questionnaires',
	templateUrl: './list-questionnaires.component.html',
	providers: [DataTracking],
	imports: [Layout, BlockListComponent, TranslatePipe]
})
@ComponentUrl('list-questionnaires')
@CredentialRequired(CredentialType.QuestionnaireAccessFull)
export class ListQuestionnairesComponent {

	@Input()
	selectedQuestionnaire?: QuestionnaireModel;

	questionnaires: QuestionnaireModel[] = [];

	constructor(private readonly navigation: NavigationService, private questionnaireService: QuestionnaireService, private readonly tracker: DataTracking) {
		questionnaireService.getAllQuestionnaires(tracker).then(questionnaires => {
			this.questionnaires = questionnaires;
		});
	}

	selectQuestionnaire(questionnaireId: string) {
		this.navigation.openRelativeView(this, 'edit-questionnaire', EditQuestionnaireComponent, false).then(view => {
			view.questionnaireId = questionnaireId;		
		});
	}
}
